import { ThemeConfig } from '@chakra-ui/react';

export const config: ThemeConfig = {
  // @ts-ignore
  initialColorMode: 'light',
  useSystemColorMode: false,
};
